<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Confirmação do Curso</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-card
          v-for="(item, index) in academic.itens"
          :key="index"
          v-show="item.visible"
        >
          <p v-if="index == 0">
            {{ academic.introduction }}
          </p>
          <div slot="header">
            <h3>
              {{ item.name }}
            </h3>
          </div>

          <p v-html="item.message">
          </p>
          <div v-if="item.field == 'lista-disciplinas'">
            <vs-row>
              <vs-col>
                <vs-divider/>
                <vs-table :data="subjects" class="pd-table">
                  <template slot="thead">
                    <th width="43%"> Disciplina </th>
                    <th width="15%"> Data Inicial </th>
                    <th width="15%"> Data Final </th>
                    <th width="27%"> Horário </th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                      class="pointer"
                    >
                      <vs-td>
                        {{ data[indextr].DISCIPLINA }}
                      </vs-td>
                      <vs-td>
                        {{ data[indextr].DTINICIAL | moment }}
                      </vs-td>
                      <vs-td>
                        {{ data[indextr].DTFINAL | moment }}
                      </vs-td>
                      <vs-td>
                        {{ data[indextr].HORARIO}}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-col>
            </vs-row>
          </div>
          <div>
            <vs-row>
              <vs-divider/>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="arrow_back"
                  style="width: 100%;"
                  @click="back(item, index)"
                  v-if="item.field !== 'nome_curso'"
                >
                  Voltar
                </vs-button>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="check_circle"
                  style="width: 100%;"
                  color="#139B0E"
                  @click="confirmAdvance(item, index)"
                >
                  Confirmar e Avançar
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </vs-card>
        <vs-card style="height: 270px">
          <h2>Divergência</h2>
          <Divergence/>
        </vs-card>
        <vs-card style="height: 140px">
          <h2>Cancelamento</h2>
          <!--Componente Cancelamento de Pré-->
          <ReasonsCancel/>
        </vs-card>
      </section>
    </div>
  </div>
</template>
<script>
  import AuditModel from "../model/Audit.js";
  import PreRegistrationService from "../services/preRegistration.js";
  import { getStepsInformation } from "../helpers/storage";
  import { formatDateToLocale } from "../helpers";
  import Divergence from "../components/Divergence.vue";
  import ReasonsCancel from "../components/ReasonsCancel.vue";
  import moment from "moment";

  export default {
    name: "AuditStep2",
    components: {
      Divergence,
      ReasonsCancel,
    },
    data: () => ({
      academic: null,
      coligateId: null,
      preRegistrationId: null,
      error: null,
      pre: null,
      subjects: [],
      errorCancel: null,
    }),
    created() {
      //montagem do objeto de confirmações financeiras
      this.academic = new AuditModel().getItem("academic");

      //puxar a pré que está salva na sessão e busca os dados da pré no endpoint
      const stepsData = getStepsInformation();
      const preRegistrationId = stepsData.preRegistrationId;

      this.$vs.loading();
      new PreRegistrationService()
        .getPreRegistration(1, preRegistrationId)
        .then((res) => {
          this.pre = res.data;
          console.log(this.pre);
          this.academic = JSON.stringify(this.academic);

          this.academic = this.academic.replace(
            "@NOMECURSO", this.pre.NOMECURSO
            );

          if (this.pre.POLOQI == null) {
            this.academic = this.academic.replace(
              "@CODFILIAL", this.pre.CODFILIAL
            );
          } else {
            this.academic = this.academic.replace(
              "@CODFILIAL", this.pre.POLOQI
              );
          }
          if (this.pre.ENDERECO_POLO == null) {
            this.academic = this.academic.replace(
              "@ENDERECOFILIAL", this.pre.ENDERECO_FILIAL
            );
          } else {
            this.academic = this.academic.replace(
              "@ENDERECOFILIAL", this.pre.ENDERECO_POLO
            );
          }
          if (this.pre.MODALIDADECURSO == 3) {
            this.academic = this.academic.replace(
              "@FORMAINGRESSO", this.pre.FORMAINGRESSO
            );
          }
          this.academic = this.academic.replace(
            "@PARTICULARIDADES", this.pre.PARTICULARIDADES.replace(/\n/g, "<br>").replace(/"/g, "")
          );

          this.academic = JSON.parse(this.academic);
          console.log(this.academic);
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });

      this.$vs.loading();
      new PreRegistrationService()
        .getSubjects(1, preRegistrationId)
        .then((res) => {
          this.subjects = res.data;
          console.log(this.subjects);
          this.$vs.loading.close();
          this.academic = JSON.stringify(this.academic);

          this.academic = this.academic.replace(
            "@BOASVINDAS", this.subjects[0].DISCIPLINA
          );
          this.academic = this.academic.replace(
            "@HORARIOBOASVINDAS", this.subjects[0].HORARIO
          );
          this.academic = this.academic.replace(
            "@DTINICIOBOASVINDAS", formatDateToLocale(this.subjects[0].DTINICIAL)
          );
          this.academic = this.academic.replace(
            "@DTINICIODISCIPLINA", this.subjects[0].TIPO == 'I' ? formatDateToLocale(this.subjects[1].DTINICIAL) : formatDateToLocale(this.subjects[0].DTINICIAL)
          );
          this.academic = this.academic.replace(
            "@DISCIPLINA", this.subjects[0].TIPO == 'I' ? this.subjects[1].DISCIPLINA : this.subjects[0].DISCIPLINA
          );
          this.academic = JSON.parse(this.academic);
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    methods: {

      confirmAdvance(item, index) {
        item.visible = false;
        item.valid = true;
        if (index == this.academic.itens.length - 1) {
          this.$router.push("/audits/3");
        } else {
          if (this.academic.itens[index + 1].modality)
            if (
              this.academic.itens[index + 1].modality != this.pre.MODALIDADECURSO
            ) {
              index = index + 1;
            }
          if (item.field == 'filial' && this.subjects[0].TIPO != 'I') {
            this.academic.itens[index + 2].visible = true;
          } else {
            this.academic.itens[index + 1].visible = true;
          }
        }
      },
      back(item, index) {
        item.visible = false;
        item.valid = true;
        if (this.academic.itens[index - 1].modality)
          if (
            this.academic.itens[index - 1].modality != this.pre.MODALIDADECURSO
          ) {
            index = index - 1;
          }
          if (item.field == 'lista-disciplinas' && this.subjects[0].TIPO != 'I') {
            this.academic.itens[index - 2].visible = true;
          } else {
            this.academic.itens[index - 1].visible = true;
          }
      },
    },
    filters: {
      moment: function (date) {
        moment.locale("pt-br");
        return moment(date).format("DD/MM/YYYY");
      },
    },
  };
</script>
<style>
  p {
    padding: 1% 1% 0% 1%;
    font-family: "Segoe UI", Tahoma, Verdana, sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #414141;
    text-align: justify;
  }
</style>
